export function validateEmail(email) {
  if (/^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,})+$/.test(email)) {
    return true;
  }
  return false;
}
